import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { get } from '@bigyouth/base'
import axios from 'axios'

// import datas from '../json/implantation-test'
import mapStyles from '../json/map-styles'

export default {
  name: 'map',

  markers: [],

  ui: {
    map: '[js-map-map]',
    'filter[]': '[js-map-filter]',
  },

  events: [
    {
      on: 'click',
      target: 'filter',
      handle (e) {
        get('[js-map-filter].is-active').classList.remove('is-active')
        e.target.classList.add('is-active')
        this.updateMarkers(e.target.dataset.filter)
      },
    },
  ],

  componentDidMount () {
    const loader = new Loader({
      apiKey: process.env.GOOGLEMAP_API_KEY,
      // apiKey: 'AIzaSyDISUa6zTsfYf93lgPJdi7U6UWn7Bx69q8',
      version: 'weekly',
      language: config.locale,
    })

    loader.load().then((google) => {
      this.map = new google.maps.Map(this.ui.map, {
        zoom: 4,
        center: {
          lat: 0,
          lng: 0,
        },
        draggable: true,
        zoomControl: true,
        scrollwheel: true,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        styles: mapStyles,
      })

      axios.get('/ajax/implantation-json')
        .then(response => {
          this.datas = response.data

          this.addMarkers()

          const urlParams = new URLSearchParams(window.location.search)
          const filterInUrl = urlParams.get('filter')

          if (filterInUrl) {
            get(`[js-map-filter][data-filter="${filterInUrl}"]`).click()
          }
        })
        .catch(e => {
          console.log()
        })
    })
  },

  addMarkers () {
    const bounds = new google.maps.LatLngBounds()

    this.datas.forEach(location => {
      const latLng = new google.maps.LatLng(location.lat, location.lng)

      const image = {
        url: `/assets/front/img/markers/${location.type}-marker.svg`,
        size: new google.maps.Size(40, 62),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 31),
      }

      const infowindow = new google.maps.InfoWindow({
        pixelOffset: new google.maps.Size(36, 72),
        content: this.createInfowindow(location),
      })

      const marker = new google.maps.Marker({
        position: latLng,
        map: this.map,
        icon: image,
        visible: location.filters.includes('france'),
      })

      this.markers.push(marker)

      google.maps.event.addListener(marker, 'click', () => {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close()
        }

        const image = {
          url: '',
          size: new google.maps.Size(40, 62),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(20, 31),
        }

        infowindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: false,
        })

        this.currentInfoWindow = infowindow

        this.markers.forEach((markerItem, i) => {
          image.url = `/assets/front/img/markers/${this.datas[i].type}-marker.svg`
          markerItem.setIcon(image)
        })

        // change for active
        image.url = `/assets/front/img/markers/${location.type}-marker-active.svg`
        marker.setIcon(image)
      })

      google.maps.event.addListener(infowindow, 'closeclick', () => {
        marker.setIcon(image)
      })

      if (location.filters.includes('france')) {
        bounds.extend(latLng)
      }
    })

    this.map.fitBounds(bounds)

    const markers = this.markers
    const map = this.map

    const renderer = {
      render ({ count, position }) {
        return new google.maps.Marker({
          label: { text: String(count), color: 'white', fontSize: '14px' },
          position,
          icon: {
            url: '/assets/front/img/markers/m2.svg',
            labelOrigin: new google.maps.Point(22, 25),
          },
          size: new google.maps.Size(43, 66),
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        })
      },
    }

    /* eslint-disable-next-line */
    new MarkerClusterer({ markers, map, renderer })
  },

  updateMarkers (filter) {
    const bounds = new google.maps.LatLngBounds()

    this.markers.forEach((marker, i) => {
      if (this.datas[i].filters.includes(filter)) {
        const latLng = new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng())

        marker.setVisible(true)
        bounds.extend(latLng)
      } else {
        marker.setVisible(false)
      }
    })

    this.map.fitBounds(bounds)
  },

  createInfowindow (location) {
    return `
      <div class="map-info">
        <svg width="40" height="36">
          <use href="#icon-${location.type}" xlink:href="#icon-${location.type}"></use>
        </svg>
        <p class="map-info__title">${location.title}</p>
        ${location.subtitle
         ? `<p class="map-info__info">${location.subtitle}</p>`
         : ''
        }
        ${location.address1
         ? `<p class="map-info__info">${location.address1}</p>`
         : ''
        }
        ${location.address2
          ? `<p class="map-info__info">${location.address2}</p>`
          : ''
        }
        ${location.address3
          ? `<p class="map-info__info">${location.address3}</p>`
          : ''
        }
        ${location.address4
         ? `<p class="map-info__info">${location.address4}</p>`
         : ''
        }
        ${location.phone
         ? `<a href="tel:${location.phone}" class="map-info__info">${location.phone}</a>`
         : ''
        }
        ${location.link
          ? `<a href="${location.link}" target="_blank" class="button button--shore-blue mt-6">${config.trads['map.website']}</a>`
          : ''
        }
      </div>
    `
  },
}
